export type AspectRatio = '1:1' | '9:16' | '16:9';
export type TextAlign = 'left' | 'center' | 'right';
export type TextTransform = 'none' | 'uppercase' | 'lowercase' | 'capitalize';
export type ElementType = 'text' | 'button' | 'shape' | 'image';
export type AdAnimation = 'none' | 'ken-burns' | 'cta-pulse' | 'spotlight' | 'text-reveal';

export interface EditorElementStyle {
  fontSize: number;
  fontFamily: string;
  color: string;
  backgroundColor: string;
  borderRadius: number;
  fontWeight: number;
  textAlign: TextAlign;
  paddingX: number;
  paddingY: number;
  opacity: number;
  letterSpacing: number;
  lineHeight: number;
  textShadow: boolean;
  border: string;
  textTransform: TextTransform;
  width?: number;  // percentage of canvas width, undefined = auto
  height?: number; // percentage of canvas height, undefined = auto
}

export interface EditorElement {
  id: string;
  type: ElementType;
  x: number; // 0-100 percentage of canvas width
  y: number; // 0-100 percentage of canvas height
  content: string;
  /** Data URL for image/logo elements */
  imageUrl?: string;
  style: EditorElementStyle;
  locked: boolean;
  visible: boolean;
}

export const DEFAULT_TEXT_STYLE: EditorElementStyle = {
  fontSize: 22,
  fontFamily: 'Inter, sans-serif',
  color: '#ffffff',
  backgroundColor: 'transparent',
  borderRadius: 0,
  fontWeight: 800,
  textAlign: 'left',
  paddingX: 0,
  paddingY: 0,
  opacity: 1,
  letterSpacing: 0,
  lineHeight: 1.2,
  textShadow: true,
  border: 'none',
  textTransform: 'none',
};

export const DEFAULT_BUTTON_STYLE: EditorElementStyle = {
  fontSize: 14,
  fontFamily: 'Inter, sans-serif',
  color: '#ffffff',
  backgroundColor: '#f97316',
  borderRadius: 12,
  fontWeight: 700,
  textAlign: 'center',
  paddingX: 20,
  paddingY: 10,
  opacity: 1,
  letterSpacing: 0.3,
  lineHeight: 1.2,
  textShadow: false,
  border: 'none',
  textTransform: 'none',
  width: 28,
};

export const DEFAULT_SUBTEXT_STYLE: EditorElementStyle = {
  fontSize: 14,
  fontFamily: 'Inter, sans-serif',
  color: 'rgba(255,255,255,0.85)',
  backgroundColor: 'transparent',
  borderRadius: 0,
  fontWeight: 500,
  textAlign: 'left',
  paddingX: 0,
  paddingY: 0,
  opacity: 1,
  letterSpacing: 0,
  lineHeight: 1.4,
  textShadow: true,
  border: 'none',
  textTransform: 'none',
};

export const DEFAULT_IMAGE_STYLE: EditorElementStyle = {
  fontSize: 14,
  fontFamily: 'Inter, sans-serif',
  color: 'transparent',
  backgroundColor: 'transparent',
  borderRadius: 0,
  fontWeight: 400,
  textAlign: 'left',
  paddingX: 0,
  paddingY: 0,
  opacity: 1,
  letterSpacing: 0,
  lineHeight: 1,
  textShadow: false,
  border: 'none',
  textTransform: 'none',
  width: 30,
};

export const FONT_OPTIONS = [
  { label: 'Inter', value: 'Inter, sans-serif' },
  { label: 'Georgia', value: 'Georgia, serif' },
  { label: 'Arial Black', value: '"Arial Black", sans-serif' },
  { label: 'Trebuchet', value: '"Trebuchet MS", sans-serif' },
  { label: 'Courier', value: '"Courier New", monospace' },
  { label: 'Impact', value: 'Impact, sans-serif' },
  { label: 'Palatino', value: '"Palatino Linotype", serif' },
  { label: 'Verdana', value: 'Verdana, sans-serif' },
];
